import { findComposePlugins } from 'owa-mail-compose-actions/lib/plugins/ComposePlugins';
import { ComposeViewState } from 'owa-mail-compose-store';

// VSO 16069 [Mac/Safari] After set importance, then typing, the cursor is not at the end.
// This is a workaround to fix the focus issue in Edge and Mac Safari
export default function focusToEditor(composeViewState: ComposeViewState) {
    const composePlugins = findComposePlugins(composeViewState);
    composePlugins.contentOperation.focusToEditor();
}
